export const translations = {
  en: {
    hero: {
      status: {
        google: "STATUS: Google for Startups Scale Tier [PENDING]",
        hub: "STATUS: Astana Hub Silkway Accelerator [CANDIDATE]",
      },
      console: {
        system: "> Core: Gemini 3 Pro (Deep Think Mode)",
        infra: "> Visuals: Agentic Vision via Gemini 3 Flash",
        protocol: "> Protocol: A2A (Agent-to-Agent) Standard",
        framework: "> Framework: Google ADK (Multi-Agent Orchestration)",
      },
      title: "Advanced Agentic AI Infrastructure",
      subtitle: "Autonomous Multi-Agent Systems for Enterprise Scale",
      cta_primary: "Explore R&D",
    },
    projects: {
      title: "Flagship Projects",
      nemesis: {
        title: "NEMESIS",
        desc: "Autonomous OSINT OS with cyclic agents. Hybrid Edge + Cloud AI for Digital Twins and Knowledge Graphs.",
        tech: "LangGraph / ADK • Gemini 3 Pro • Neo4j • LightRAG",
        popup: {
          id: "nemesis",
          fullTitle: "NEMESIS Platform",
          subtitle: "Autonomous OSINT OS for Fusion Analytics",
          status: "OSINT_FUSION",
          statusColor: "bg-amber/20 text-amber",
          sections: [
            {
              id: "summary",
              tag: "EXEC_SUMMARY",
              title: "Executive Summary",
              content: "<p><strong>NEMESIS</strong> — Autonomous OS for OSINT investigations and Fusion Analytics, built on hybrid architecture (Edge + Cloud AI).</p><p class='mt-2'>We combine local data privacy with global neural network power to create <strong>Digital Twins</strong> and <strong>Knowledge Graphs</strong>.</p><p class='mt-2 text-amber'>Elevator Pitch: LangGraph for cyclic agentic workflows + Gemini 3 Pro reasoning + Neo4j Knowledge Graph on private secure servers.</p>"
            },
            {
              id: "architecture",
              tag: "HYBRID_COMPUTE",
              title: "Hybrid Architecture",
              content: "<div class='space-y-3'><p><strong>Orchestration Engine:</strong> LangGraph — cyclic graphs instead of linear DAG. Plan → Act → Verify → Re-plan cycle.</p><p><strong>Core Logic:</strong> Business logic on protected private servers. Private Knowledge Graph.</p><p><strong>Heavy AI Offloading:</strong> Resource-intensive tasks (Computer Vision, GeoAI, LLM Reasoning) via SOTA model APIs. 90% infrastructure cost reduction vs own GPU cluster.</p></div>"
            },
            {
              id: "ai-council",
              tag: "MULTI_MODEL",
              title: "AI Council (Mixture of Agents)",
              content: "<div class='space-y-2'><p><strong>The Brain:</strong> Gemini 3 Pro (Large Context) — strategic planning, massive data context retention</p><p><strong>The Hands:</strong> GPT-5.2, Claude Opus 4.5, Gemini 3 Pro — code writing, Tool Use</p><p><strong>The Researcher:</strong> Grok 4 — social graph analysis, real-time X/Twitter search</p><p><strong>Visual Intelligence:</strong> SAM 3 (Meta), InsightFace v2, GeoSpy.ai (GeoINT)</p></div>"
            },
            {
              id: "knowledge-graph",
              tag: "DATA_FUSION",
              title: "Knowledge Graph & Memory",
              content: "<ul class='list-disc pl-5 space-y-2'><li><strong>Neo4j:</strong> Graph DB for entity relationships (People, Companies, Transactions, Geolocations)</li><li><strong>LightRAG:</strong> Graph-based RAG engine. Incremental knowledge updates from thousands of documents</li><li><strong>Entity Resolution:</strong> Zingg + Fuzzy Logic for deduplication and Digital Twin creation</li></ul>"
            },
            {
              id: "google",
              tag: "INFRA",
              title: "Best of Both Worlds",
              content: "<p class='mb-4'>Enterprise-grade infrastructure meets open-source flexibility. We leverage Google's global scale while integrating best-in-class open tools.</p><ul class='list-disc pl-5 space-y-2'><li><strong>Google Cloud:</strong> Vertex AI, Compute Engine, global CDN</li><li><strong>Open-Source Power:</strong> Neo4j, LangGraph, LightRAG, Zingg</li><li><strong>Hybrid Edge + Cloud:</strong> Sensitive data stays private, heavy compute scales in cloud</li></ul><p class='mt-4 text-amber'>NEMESIS — not just OSINT. Autonomous intelligence that turns raw data into verified Knowledge Graphs.</p>"
            }
          ]
        }
      },
      dental: {
        title: "DentalGuard AI",
        desc: "Hybrid Edge/Cloud Monitoring. Agentic Vision (Gemini 3 Flash) for real-time fraud detection.",
        tech: "Gemini 3 Flash • YOLO26/12 • MedSAM 3",
        popup: {
          id: "dental-guard",
          fullTitle: "DentalGuard AI",
          subtitle: "Multimodal Intelligence Ecosystem for Dentistry",
          status: "SMART_CLINIC",
          statusColor: "bg-emerald-500/20 text-emerald-400",
          sections: [
            {
              id: "summary",
              tag: "EXEC_SUMMARY",
              title: "Executive Summary",
              content: "<p><strong>DentalGuard AI</strong> — The first implementation of <strong>Agentic Vision</strong> in healthcare.</p><p class='mt-2'>Using the <strong>Think-Act-Observe</strong> loop via Google ADK, the agent analyzes doctor actions effectively preventing fraud and errors. Powered by <strong>YOLO26/12</strong> for sub-millisecond detection.</p><p class='mt-2 text-amber'>Tech Stack: Gemini 3 Flash for visual reasoning + Edge TPU for local processing.</p>"
            },
            {
              id: "architecture",
              tag: "ARCH_MATRIX",
              title: "Architecture & Scalability",
              content: "<div class='space-y-3'><p><strong>Level 1: Smart Sensor (MVP)</strong><br/>NVIDIA Jetson Orin Nano Super (67 TOPS) + Arducam AR0234 (Global Shutter). Local YOLO26/12 detection.</p><p><strong>Level 2: Pro Vision (Active 3D)</strong><br/>Luxonis OAK-4-D Pro (IR depth) + AMD Ryzen AI Max+ 395 server. 3D reconstruction, local VLM (Gemma 3).</p><p><strong>Level 3: Enterprise Core</strong><br/>NVIDIA DGX Spark (Blackwell). FP4 support for MedSAM-3 + multi-agent orchestration for 20+ chairs.</p></div>"
            },
            {
              id: "tech",
              tag: "TECH_STACK_2026",
              title: "Technology Stack",
              content: "<div class='space-y-2'><p><strong>Vision:</strong> YOLO26/12 (End-to-End, STAL), MedSAM-3, NVIDIA Holoscan, Isaac ROS Stereo</p><p><strong>Audio:</strong> DeepFilterNet 3 (turbine denoising), Whisper v3 Turbo, Deepgram Nova-3 Medical</p><p><strong>Cognition:</strong> Gemma 3 (Edge, 2B/8B), Gemini 3 Pro (Cloud Reasoning), Gemini Live (incident analysis)</p></div>"
            },
            {
              id: "privacy",
              tag: "PRIVACY_FIRST",
              title: "Privacy & Security",
              content: "<p>HIPAA / GDPR / 152-ФЗ compliant by design:</p><ul class='list-disc pl-5 mt-2 space-y-1'><li><strong>Local-First:</strong> Video processing inside clinic (Edge/Local Server)</li><li><strong>De-identification:</strong> Face blurring, PII removal (Microsoft Presidio)</li><li><strong>Synthetic Evidence:</strong> Reports use segmentation masks, not raw video</li></ul>"
            },
            {
              id: "features",
              tag: "FEATURE_SET",
              title: "Features & Value",
              content: "<div class='grid grid-cols-2 gap-4'><div><p class='text-amber font-bold'>Anti-Fraud Module</p><ul class='text-xs mt-1 space-y-1'><li>Ghost Services detection</li><li>Cash Bypass audio triggers</li><li>Time Fraud verification</li></ul></div><div><p class='text-green-400 font-bold'>Clinical Assistant</p><ul class='text-xs mt-1 space-y-1'><li>Digital Loupes (2K zoom)</li><li>3D Safety Control</li><li>Auto-documentation</li></ul></div></div>"
            },
            {
              id: "google",
              tag: "INFRA",
              title: "Why Google?",
              content: "<p class='mb-4'>Google is a tech giant that wins marathons. Gemini leads global benchmarks. We're building on a foundation that will be relevant for the next 10 years.</p><ul class='list-disc pl-5 space-y-2'><li><strong>Vertex AI:</strong> Enterprise-grade infrastructure with global availability</li><li><strong>Edge TPU & Gemma:</strong> Local inference for data privacy</li><li><strong>Gemini 3 Pro:</strong> SOTA multimodal reasoning for complex medical cases</li></ul><p class='mt-4 text-amber'>DentalGuard AI — not just a camera. An intelligent partner making medicine transparent, safe, and technological.</p>"
            }
          ]
        }
      },
      accountant: {
        title: "AWP-SA",
        desc: "Agentic B2B SaaS. Multi-agent orchestration via Google ADK for autonomous financial balancing.",
        tech: "Google ADK • Multi-Agent A2A • Vertex AI",
        popup: {
          id: "arm-accountant",
          fullTitle: "AWP-SA: Automated WorkPlace — System Accountant",
          subtitle: "Intelligent Automation for Accounting Companies",
          status: "BETA",
          statusColor: "bg-purple-500/20 text-purple-400",
          sections: [
            {
              id: "summary",
              tag: "SUMMARY",
              title: "About the Project",
              content: "<p><strong>AWP-SA</strong> — comprehensive SaaS system for accounting companies covering the full management cycle: from calculating service costs to controlling client profitability.</p><p class='mt-2'>The system helps managers see the real business picture, and accountants — work more efficiently.</p><p class='mt-2 text-amber'>Key idea: Accounting is production, not chaos. AWP-SA transforms 'creative disorder' into a measurable, manageable process.</p>"
            },
            {
              id: "core",
              tag: "PHILOSOPHY",
              title: "4 Stages of Control",
              content: "<div class='space-y-2'><p class='text-amber font-mono'>📋 PLAN → ⚡ FACT → 🛡️ CONTROL → 📈 GROWTH</p><ul class='list-disc pl-5 mt-3 space-y-1'><li><strong>Plan:</strong> Define scope and cost of work (EstimatePro)</li><li><strong>Fact:</strong> Record completed tasks and time (TimeTrack)</li><li><strong>Control:</strong> Compare plan vs fact, find deviations</li><li><strong>Growth:</strong> Improve processes, scale results</li></ul></div>"
            },
            {
              id: "modules",
              tag: "MODULES",
              title: "Functionality + AI",
              content: "<div class='space-y-3'><p><strong>EstimatePro:</strong> Service pricing → <span class='text-green-400'>AI: semantic search, auto-generation of estimates</span></p><p><strong>TimeTrack:</strong> Work time accounting → <span class='text-green-400'>AI: labor cost prediction, unprofitability detector</span></p><p><strong>TaskFlow:</strong> Reporting calendar → <span class='text-green-400'>AI: smart reminders, AI-planning</span></p><p><strong>QualityCheck:</strong> Quality checklists → <span class='text-green-400'>AI: quality control, pattern detection</span></p></div>"
            },
            {
              id: "agent",
              tag: "AI_AGENT",
              title: "EstimatePro Agent",
              content: "<div class='space-y-2'><p><strong>Go 1.24 + Google ADK v0.3.0</strong> — microservice for intelligent automation.</p><ul class='list-disc pl-5 mt-2 space-y-1'><li><strong>Semantic search:</strong> Finds relevant services by meaning, not keywords</li><li><strong>OCR Vision:</strong> Instant extraction of company details from image/PDF — just upload and done</li><li><strong>Tool Calling:</strong> Integrates with database via ADK</li><li><strong>Modes:</strong> template, search, auto — flexible routing</li></ul><p class='mt-2 text-amber'>Gemini 3 Flash + Gemini Embeddings (1536 dim, MRL) + pgvector HNSW</p></div>"
            },
            {
              id: "stack",
              tag: "SYNERGY",
              title: "Stack Synergy",
              content: "<p class='mb-3'>Go Agent on Google ADK provides low latency and native integration with Gemini API. Embeddings in pgvector enable semantic search without external dependencies.</p><ul class='list-disc pl-5 space-y-1'><li><strong>Go + ADK:</strong> Lightweight, fast, native Google integration</li><li><strong>Gemini Embeddings:</strong> 1536-dim vectors with MRL support</li><li><strong>pgvector HNSW:</strong> Local vector search, no vendor lock-in</li></ul><p class='mt-3 text-amber'>Result: AI features work fast and predictably in enterprise environment.</p>"
            }
          ]
        }
      },
    },
    stack: {
      title: "The 2026 Tech Stack",
      columns: { tech: "Technology", app: "Application" },
      items: [
        { tech: "Gemini 3 Pro / Flash / Live", app: "Multimodal Reasoning & Real-time Interaction" },
        { tech: "Google ADK", app: "Hierarchical Agent Teams Orchestration" },
        { tech: "A2A Protocol", app: "Inter-Agent Communication Standard" },
        { tech: "Google Antigravity & IDX", app: "Full-Cycle Acceleration: Research → Dev → Deploy" },
        { tech: "Project Mariner / Vertex AI", app: "Autonomous Navigation & Enterprise Deployment" },
      ],
    },
    team: {
      title: "Leadership",
      members: [
        { name: "Kirill Zinoveykin", role: "Co-Founder & CEO", img: "/team/kirill.jpg", linkedin: "https://www.linkedin.com/in/zinoveyking/" },
        { name: "Gennadii Gomanovich", role: "Co-Founder & CTO", img: "/team/gennady.JPG", linkedin: "https://www.linkedin.com/in/gennady87/" },
      ]
    },
    contact: {
      title: "Connect to Grid",
      email: "info@next3.ai",
      address: "12 Kosmonavtov St., Karaganda, 100022, Kazakhstan",
      form: {
        name: "Agent Name",
        phone: "Secure Line",
        email: "Neural Link (Email)",
        message: "Mission Protocol",
        submit: "Transmit Data",
      },
      placeholders: {
        names: ["Agent Smith", "Neo", "Deckard", "Cyber-V", "Motoko", "47"],
        phones: ["+1 (555) 019-2834", "+44 20 7946 0958", "+81 90-1234-5678", "+971 50 123 4567"],
        emails: ["neo@matrix.com", "deckard@bladerunner.off", "v@nightcity.net", "motoko@section9.jp"],
        messages: ["Requesting extraction...", "System breach detected...", "Initiating handshake protocol...", "Uploading data packet...", "Connection unstable..."],
      },
    },
    nav: {
      features: "Projects",
      stack: "Stack",
      team: "Team",
      contact: "Uplink",
    },
    footer: {
      copyright: "next³ Agentic AI Lab © 2026",
      powered: "Google Cloud • Vertex AI • Astana Hub",
    },
  },
  ru: {
    hero: {
      status: {
        google: "СТАТУС: Google for Startups Scale Tier [ЗАЯВКА]",
        hub: "СТАТУС: Astana Hub Silkway Accelerator [КАНДИДАТ]",
      },
      console: {
        system: "> Ядро: Gemini 3 Pro (Deep Think Mode)",
        infra: "> Визуал: Agentic Vision via Gemini 3 Flash",
        protocol: "> Протокол: A2A (Agent-to-Agent) Standard",
        framework: "> Фреймворк: Google ADK (Мульти-агентная оркестрация)",
      },
      title: "Агентные ИИ Решения",
      subtitle: "Автономные мульти-агентные системы уровня Enterprise",
      cta_primary: "Изучить Разработки",
    },
    projects: {
      title: "Флагманские Проекты",
      nemesis: {
        title: "NEMESIS",
        desc: "Автономная ОС для OSINT-расследований и Fusion-аналитики на гибридной архитектуре (Edge + Cloud AI).",
        tech: "LangGraph / ADK • Gemini 3 Pro • Neo4j • LightRAG",
        popup: {
          id: "nemesis",
          fullTitle: "NEMESIS Platform",
          subtitle: "Автономная ОС для OSINT-расследований и Fusion-аналитики",
          status: "OSINT_FUSION",
          statusColor: "bg-amber/20 text-amber",
          sections: [
            {
              id: "summary",
              tag: "РЕЗЮМЕ",
              title: "Краткое Описание",
              content: "<p><strong>NEMESIS</strong> — Автономная ОС для OSINT-расследований и Fusion-аналитики на гибридной архитектуре (Edge + Cloud AI).</p><p class='mt-2'>Мы объединили локальную приватность данных с мощностью глобальных нейросетей для создания <strong>Цифровых Двойников</strong> и <strong>Графов Знаний</strong>.</p><p class='mt-2 text-amber'>Elevator Pitch: LangGraph для циклических агентных воркфлоу + Gemini 3 Pro reasoning + Neo4j Knowledge Graph на приватных защищённых серверах.</p>"
            },
            {
              id: "architecture",
              tag: "АРХИТЕКТУРА",
              title: "Гибридная Архитектура",
              content: "<div class='space-y-3'><p><strong>Orchestration Engine:</strong> LangGraph — циклические графы вместо линейных DAG. Цикл Plan → Act → Verify → Re-plan.</p><p><strong>Core Logic:</strong> Бизнес-логика на защищённых приватных серверах. Приватный Граф Знаний.</p><p><strong>Heavy AI Offloading:</strong> Ресурсоёмкие задачи (Computer Vision, GeoAI, LLM Reasoning) через API SOTA-моделей. Снижение стоимости инфраструктуры на 90%.</p></div>"
            },
            {
              id: "ai-council",
              tag: "AI_COUNCIL",
              title: "Совет ИИ (Mixture of Agents)",
              content: "<div class='space-y-2'><p><strong>The Brain:</strong> Gemini 3 Pro (Large Context) — стратегическое планирование, удержание контекста</p><p><strong>The Hands:</strong> GPT-5.2, Claude Opus 4.5, Gemini 3 Pro — написание кода, Tool Use</p><p><strong>The Researcher:</strong> Grok 4 — анализ социальных графов, real-time поиск по X/Twitter</p><p><strong>Visual Intelligence:</strong> SAM 3 (Meta), InsightFace v2, GeoSpy.ai (GeoINT)</p></div>"
            },
            {
              id: "knowledge-graph",
              tag: "ГРАФ_ЗНАНИЙ",
              title: "Граф Знаний и Память",
              content: "<ul class='list-disc pl-5 space-y-2'><li><strong>Neo4j:</strong> Графовая БД для связей между сущностями (Люди, Компании, Транзакции, Геолокации)</li><li><strong>LightRAG:</strong> RAG-движок на графах. Инкрементальное обновление знаний из тысяч документов</li><li><strong>Entity Resolution:</strong> Zingg + Fuzzy Logic для дедупликации и создания Цифровых Двойников</li></ul>"
            },
            {
              id: "google",
              tag: "ИНФРА",
              title: "Лучшее из двух миров",
              content: "<p class='mb-4'>Enterprise-инфраструктура + гибкость open-source. Мы используем глобальный масштаб Google и интегрируем лучшие открытые инструменты.</p><ul class='list-disc pl-5 space-y-2'><li><strong>Google Cloud:</strong> Vertex AI, Compute Engine, глобальный CDN</li><li><strong>Open-Source мощь:</strong> Neo4j, LangGraph, LightRAG, Zingg</li><li><strong>Гибрид Edge + Cloud:</strong> Чувствительные данные остаются приватными, тяжёлые вычисления уходят в облако</li></ul><p class='mt-4 text-amber'>NEMESIS — не просто OSINT. Автономный интеллект, превращающий сырые данные в верифицированные Графы Знаний.</p>"
            }
          ]
        }
      },
      dental: {
        title: "DentalGuard AI",
        desc: "Гибридная Edge-Cloud платформа для стоматологии. Компьютерное зрение, 3D-навигация и агентные модели.",
        tech: "Gemma 3 • Gemini 3 Pro • MedSAM",
        popup: {
          id: "dental-guard",
          fullTitle: "DentalGuard AI",
          subtitle: "Мультимодальная Интеллектуальная Экосистема для Стоматологии",
          status: "SMART_CLINIC",
          statusColor: "bg-emerald-500/20 text-emerald-400",
          sections: [
            {
              id: "summary",
              tag: "РЕЗЮМЕ",
              title: "Краткое Описание",
              content: "<p><strong>DentalGuard AI</strong> — Гибридная Edge-Cloud платформа, превращающая стоматологические кресла в интеллектуальные IoT-узлы.</p><p class='mt-2'>Мы комбинируем компьютерное зрение реального времени (SOTA 2026), активную 3D-навигацию и агентные модели для автоматизированного контроля качества, выявления мошенничества и помощи врачу.</p><p class='mt-2 text-amber'>Миссия: <strong>Клиника без клика</strong> — где врач лечит, а ИИ документирует, предотвращает ошибки и защищает бизнес.</p>"
            },
            {
              id: "architecture",
              tag: "АРХИТЕКТУРА",
              title: "Архитектура и Масштабирование",
              content: "<div class='space-y-3'><p><strong>Уровень 1: Smart Sensor (MVP)</strong><br/>NVIDIA Jetson Orin Nano Super (67 TOPS) + Arducam AR0234 (Global Shutter). Локальная детекция YOLO12.</p><p><strong>Уровень 2: Pro Vision (Active 3D)</strong><br/>Luxonis OAK-4-D Pro (IR глубина) + AMD Ryzen AI Max+ 395 сервер. 3D-реконструкция, локальная VLM (Gemma 3).</p><p><strong>Уровень 3: Enterprise Core</strong><br/>NVIDIA DGX Spark (Blackwell). Поддержка FP4 для MedSAM-3 + мульти-агентная оркестрация для 20+ кресел.</p></div>"
            },
            {
              id: "tech",
              tag: "СТЕК_2026",
              title: "Технологический Стек",
              content: "<div class='space-y-2'><p><strong>Зрение:</strong> YOLO26/12 (End-to-End, STAL), MedSAM-3, NVIDIA Holoscan, Isaac ROS Stereo</p><p><strong>Аудио:</strong> DeepFilterNet 3 (подавление шума турбины), Whisper v3 Turbo, Deepgram Nova-3 Medical</p><p><strong>Когнитив:</strong> Gemma 3 (Edge, 2B/8B), Gemini 3 Pro (Cloud Reasoning), Gemini Live (анализ инцидентов)</p></div>"
            },
            {
              id: "privacy",
              tag: "ПРИВАТНОСТЬ",
              title: "Приватность и Безопасность",
              content: "<p>Соответствие HIPAA / GDPR / 152-ФЗ by design:</p><ul class='list-disc pl-5 mt-2 space-y-1'><li><strong>Local-First:</strong> Обработка видео внутри клиники (Edge/Local Server)</li><li><strong>Деидентификация:</strong> Размытие лиц, удаление PII (Microsoft Presidio)</li><li><strong>Синтетические доказательства:</strong> Отчеты используют маски сегментации, а не сырое видео</li></ul>"
            },
            {
              id: "features",
              tag: "ФУНКЦИИ",
              title: "Функции и Ценность",
              content: "<div class='grid grid-cols-2 gap-4'><div><p class='text-amber font-bold'>Модуль Анти-Фрод</p><ul class='text-xs mt-1 space-y-1'><li>Детекция фантомных услуг</li><li>Аудио-триггеры обхода кассы</li><li>Верификация временного фрода</li></ul></div><div><p class='text-green-400 font-bold'>Клинический Ассистент</p><ul class='text-xs mt-1 space-y-1'><li>Цифровые лупы (2K zoom)</li><li>3D контроль безопасности</li><li>Авто-документирование</li></ul></div></div>"
            },
            {
              id: "google",
              tag: "ИНФРА",
              title: "Почему Google?",
              content: "<p class='mb-4'>Google — технологический гигант, который выигрывает марафоны. Gemini лидирует в мировых бенчмарках. Мы строим на фундаменте, который будет актуален через 10 лет.</p><ul class='list-disc pl-5 space-y-2'><li><strong>Vertex AI:</strong> Enterprise-инфраструктура с глобальной доступностью</li><li><strong>Edge TPU & Gemma:</strong> Локальный инференс для приватности данных</li><li><strong>Gemini 3 Pro:</strong> SOTA мультимодальное рассуждение для сложных медицинских случаев</li></ul><p class='mt-4 text-amber'>DentalGuard AI — не просто камера. Интеллектуальный партнер, делающий медицину прозрачной, безопасной и технологичной.</p>"
            }
          ]
        }
      },
      accountant: {
        title: "АРМ СБ",
        desc: "SaaS для бухгалтерского аутсорсинга. AI-агент автоматизирует расчёт смет и контроль рентабельности клиентов.",
        tech: "Go Agent • Google ADK • Gemini Embeddings",
        popup: {
          id: "arm-accountant",
          fullTitle: "АРМ Системный Бухгалтер",
          subtitle: "Интеллектуальная автоматизация для бухгалтерских компаний",
          status: "BETA",
          statusColor: "bg-purple-500/20 text-purple-400",
          sections: [
            {
              id: "summary",
              tag: "ОБЗОР",
              title: "О проекте",
              content: "<p><strong>АРМ-СБ</strong> — комплексная SaaS-система для бухгалтерских компаний, которая закрывает полный цикл управления: от расчёта стоимости услуг до контроля рентабельности клиентов.</p><p class='mt-2'>Система помогает руководителям видеть реальную картину бизнеса, а бухгалтерам — работать эффективнее.</p><p class='mt-2 text-amber'>Ключевая идея: Бухгалтерия — это производство, не хаос. АРМ-СБ превращает \"творческий беспорядок\" в измеримый, управляемый процесс.</p>"
            },
            {
              id: "core",
              tag: "ФИЛОСОФИЯ",
              title: "4 этапа контроля",
              content: "<div class='space-y-2'><p class='text-amber font-mono'>📋 ПЛАН → ⚡ ФАКТ → 🛡️ КОНТРОЛЬ → 📈 РОСТ</p><ul class='list-disc pl-5 mt-3 space-y-1'><li><strong>План:</strong> Определяем объём и стоимость работ (БухСмета)</li><li><strong>Факт:</strong> Фиксируем выполненные задачи и время (ФРВ)</li><li><strong>Контроль:</strong> Сверяем план и факт, находим отклонения</li><li><strong>Рост:</strong> Улучшаем процессы, масштабируем результат</li></ul></div>"
            },
            {
              id: "modules",
              tag: "МОДУЛИ",
              title: "Функционал + AI",
              content: "<div class='space-y-3'><p><strong>БухСмета:</strong> Ценообразование услуг → <span class='text-green-400'>AI: семантический поиск, автогенерация смет</span></p><p><strong>ФРВ:</strong> Учёт рабочего времени → <span class='text-green-400'>AI: предсказание трудозатрат, детектор убыточности</span></p><p><strong>БухЗадачник:</strong> Календарь отчётности → <span class='text-green-400'>AI: умные напоминания, AI-планирование</span></p><p><strong>Стандартизация:</strong> Чек-листы качества → <span class='text-green-400'>AI: контроль качества, выявление паттернов</span></p></div>"
            },
            {
              id: "agent",
              tag: "AI_АГЕНТ",
              title: "BuhSmeta Agent",
              content: "<div class='space-y-2'><p><strong>Go 1.24 + Google ADK v0.3.0</strong> — микросервис для интеллектуальной автоматизации.</p><ul class='list-disc pl-5 mt-2 space-y-1'><li><strong>Семантический поиск:</strong> Находит релевантные услуги по смыслу, а не по ключевым словам</li><li><strong>OCR Vision:</strong> Мгновенное извлечение реквизитов из фото/PDF — загрузил и готово</li><li><strong>Tool Calling:</strong> Интеграция с БД через ADK</li><li><strong>Режимы:</strong> template, search, auto — гибкая маршрутизация</li></ul><p class='mt-2 text-amber'>Gemini 3 Flash + Gemini Embeddings (1536 dim, MRL) + pgvector HNSW</p></div>"
            },
            {
              id: "stack",
              tag: "СИНЕРГИЯ",
              title: "Синергия стека",
              content: "<p class='mb-3'>Go Agent на Google ADK обеспечивает низкую латентность и нативную интеграцию с Gemini API. Embeddings в pgvector дают семантический поиск без внешних зависимостей.</p><ul class='list-disc pl-5 space-y-1'><li><strong>Go + ADK:</strong> Легковесный, быстрый, нативная интеграция с Google</li><li><strong>Gemini Embeddings:</strong> 1536-мерные вектора с поддержкой MRL</li><li><strong>pgvector HNSW:</strong> Локальный векторный поиск, без vendor lock-in</li></ul><p class='mt-3 text-amber'>Результат: AI-функции работают быстро и предсказуемо в enterprise-окружении.</p>"
            }
          ]
        }
      },
    },
    stack: {
      title: "Технологический Стек 2026",
      columns: { tech: "Технология", app: "Применение" },
      items: [
        { tech: "Gemini 3 Pro / Flash / Live", app: "Мультимодальное мышление и режим Live" },
        { tech: "Google ADK", app: "Оркестрация иерархических команд агентов" },
        { tech: "A2A Protocol", app: "Стандарт меж-агентного взаимодействия" },
        { tech: "Google Antigravity & IDX", app: "Ускорение полного цикла: Поиск → Разработка → Деплой" },
        { tech: "Project Mariner / Vertex AI", app: "Автономная навигация и Корпоративное развертывание" },
      ],
    },
    team: {
      title: "Команда",
      members: [
        { name: "Кирилл Зиновейкин", role: "Co-Founder & CEO", img: "/team/kirill.jpg", linkedin: "https://www.linkedin.com/in/zinoveyking/" },
        { name: "Геннадий Гоманович", role: "Co-Founder & CTO", img: "/team/gennady.JPG", linkedin: "https://www.linkedin.com/in/gennady87/" },
      ]
    },
    contact: {
      title: "Подключение к Сети",
      email: "info@next3.ai",
      address: "ул. Космонавтов, 12, Караганда, 100022, Казахстан",
      form: {
        name: "Имя (Позывной)",
        phone: "Защищенная Линия",
        email: "Email (Канал связи)",
        message: "Протокол Миссии",
        submit: "Передать Данные",
      },
      placeholders: {
        names: ["Агент Смит", "Нео", "Декард", "Кибер-V", "Мотоко", "47"],
        phones: ["+7 (777) 777-77-77", "+7 (999) 123-45-67", "+7 (495) 000-00-00", "+1 (555) 019-2834"],
        emails: ["neo@matrix.com", "hero@next3.ai", "admin@cyber.net", "guest@future.io"],
        messages: ["Запрос на эвакуацию...", "Обнаружен взлом системы...", "Инициация протокола...", "Загрузка пакета данных...", "Нестабильное соединение..."],
      },
    },
    nav: {
      features: "Проекты",
      stack: "Стек",
      team: "Команда",
      contact: "Связь",
    },
    footer: {
      copyright: "next³ Agentic AI Lab © 2026",
      powered: "Google Cloud • Vertex AI • Astana Hub",
    },
  },
  kz: {
    hero: {
      status: {
        google: "СТАТУС: Google for Startups Scale Tier [ӨТІНІМ]",
        hub: "СТАТУС: Astana Hub Silkway Accelerator [КАНДИДАТ]",
      },
      console: {
        system: "> Core: Gemini 3 Pro (Deep Think Mode)",
        infra: "> Visuals: Agentic Vision via Gemini 3 Flash",
        protocol: "> Хаттама: A2A (Agent-to-Agent) Standard",
        framework: "> Фреймворк: Google ADK (Мульти-агенттік оркестрация)",
      },
      title: "Агенттік ИИ Шешімдері",
      subtitle: "Кәсіпорын деңгейіндегі автономды мульти-агенттік жүйелер",
      cta_primary: "Әзірлемелерді Көру",
    },
    projects: {
      title: "Флагмандық Жобалар",
      nemesis: {
        title: "NEMESIS",
        desc: "Циклдік агенттері бар автономды OSINT-платформа. Сандық егіздер мен Білім Графтары үшін гибридті Edge + Cloud AI.",
        tech: "LangGraph / ADK • Gemini 3 Pro • Neo4j • LightRAG",
        popup: {
          id: "nemesis",
          fullTitle: "NEMESIS Platform",
          subtitle: "OSINT-тергеулер мен Fusion-аналитика үшін автономды ОЖ",
          status: "OSINT_FUSION",
          statusColor: "bg-amber/20 text-amber",
          sections: [
            {
              id: "summary",
              tag: "ТҮЙІН",
              title: "Қысқаша Сипаттама",
              content: "<p><strong>NEMESIS</strong> — OSINT-тергеулер мен Fusion-аналитика үшін гибридті архитектурадағы (Edge + Cloud AI) автономды ОЖ.</p><p class='mt-2'>Біз <strong>Сандық Егіздер</strong> мен <strong>Білім Графтарын</strong> құру үшін жергілікті деректер құпиялылығын жаһандық нейрожелілер қуатымен біріктірдік.</p><p class='mt-2 text-amber'>Elevator Pitch: Циклдік агенттік воркфлоулар үшін LangGraph + Gemini 3 Pro reasoning + қорғалған жеке серверлердегі Neo4j Knowledge Graph.</p>"
            },
            {
              id: "architecture",
              tag: "АРХИТЕКТУРА",
              title: "Гибридті Архитектура",
              content: "<div class='space-y-3'><p><strong>Orchestration Engine:</strong> LangGraph — сызықтық DAG орнына циклдік графтар. Plan → Act → Verify → Re-plan циклі.</p><p><strong>Core Logic:</strong> Қорғалған жеке серверлердегі бизнес-логика. Жеке Білім Графы.</p><p><strong>Heavy AI Offloading:</strong> Ресурс көп қажет ететін тапсырмалар (Computer Vision, GeoAI, LLM Reasoning) SOTA-модель API арқылы. Инфрақұрылым құнын 90% төмендету.</p></div>"
            },
            {
              id: "ai-council",
              tag: "AI_COUNCIL",
              title: "ЖИ Кеңесі (Mixture of Agents)",
              content: "<div class='space-y-2'><p><strong>The Brain:</strong> Gemini 3 Pro (Large Context) — стратегиялық жоспарлау, контекстті ұстау</p><p><strong>The Hands:</strong> GPT-5.2, Claude Opus 4.5, Gemini 3 Pro — код жазу, Tool Use</p><p><strong>The Researcher:</strong> Grok 4 — әлеуметтік граф талдауы, X/Twitter real-time іздеу</p><p><strong>Visual Intelligence:</strong> SAM 3 (Meta), InsightFace v2, GeoSpy.ai (GeoINT)</p></div>"
            },
            {
              id: "knowledge-graph",
              tag: "БІЛІМ_ГРАФЫ",
              title: "Білім Графы және Жады",
              content: "<ul class='list-disc pl-5 space-y-2'><li><strong>Neo4j:</strong> Нысандар арасындағы байланыстар үшін граф ДБ (Адамдар, Компаниялар, Транзакциялар, Геолокациялар)</li><li><strong>LightRAG:</strong> Графтардағы RAG-қозғалтқыш. Мыңдаған құжаттардан білімді инкрементті жаңарту</li><li><strong>Entity Resolution:</strong> Дедупликация және Сандық Егіздер құру үшін Zingg + Fuzzy Logic</li></ul>"
            },
            {
              id: "google",
              tag: "ИНФРА",
              title: "Екі әлемнің ең жақсысы",
              content: "<p class='mb-4'>Enterprise-инфрақұрылым + open-source икемділігі. Біз Google-дің жаһандық масштабын пайдаланамыз және үздік ашық құралдарды інтеграциялаймыз.</p><ul class='list-disc pl-5 space-y-2'><li><strong>Google Cloud:</strong> Vertex AI, Compute Engine, жаһандық CDN</li><li><strong>Open-Source қуаты:</strong> Neo4j, LangGraph, LightRAG, Zingg</li><li><strong>Гибрид Edge + Cloud:</strong> Сезімтал деректер құпия қалады, ауыр есептеулер бұлтқа кетеді</li></ul><p class='mt-4 text-amber'>NEMESIS — жай OSINT емес. Шикі деректерді расталған Білім Графтарына айналдыратын автономды интеллект.</p>"
            }
          ]
        }
      },
      dental: {
        title: "DentalGuard AI",
        desc: "Hybrid Edge/Cloud Monitoring. Agentic Vision (Gemini 3 Flash). ҚР клиникалары үшін бейімделген.",
        tech: "Gemini 3 Flash • YOLO26/12 • MedSAM 3",
        popup: {
          id: "dental-guard",
          fullTitle: "DentalGuard AI",
          subtitle: "Стоматологияға арналған мультимодальды интеллектуалды экожүйе",
          status: "SMART_CLINIC",
          statusColor: "bg-emerald-500/20 text-emerald-400",
          sections: [
            {
              id: "summary",
              tag: "ТҮЙІН",
              title: "Қысқаша Сипаттама",
              content: "<p><strong>DentalGuard AI</strong> — Стоматологиялық креслоларды зияткерлік IoT-түйіндерге айналдыратын гибридті Edge-Cloud платформа.</p><p class='mt-2'>Біз нақты уақыттағы компьютерлік көру (SOTA 2026), белсенді 3D-навигация және автоматтандырылған сапа бақылауы, алаяқтықты анықтау және дәрігерге көмек үшін агенттік модельдерді біріктіреміз.</p><p class='mt-2 text-amber'>Миссия: <strong>Шертусіз Клиника</strong> — дәрігер емдейді, ал ЖИ құжаттайды, қателіктердің алдын алады және бизнесті қорғайды.</p>"
            },
            {
              id: "architecture",
              tag: "АРХИТЕКТУРА",
              title: "Архитектура және Масштабтау",
              content: "<div class='space-y-3'><p><strong>Деңгей 1: Smart Sensor (MVP)</strong><br/>NVIDIA Jetson Orin Nano Super (67 TOPS) + Arducam AR0234 (Global Shutter). Жергілікті YOLO12 детекциясы.</p><p><strong>Деңгей 2: Pro Vision (Active 3D)</strong><br/>Luxonis OAK-4-D Pro (IR тереңдік) + AMD Ryzen AI Max+ 395 сервер. 3D-қайта құру, жергілікті VLM (Gemma 3).</p><p><strong>Деңгей 3: Enterprise Core</strong><br/>NVIDIA DGX Spark (Blackwell). MedSAM-3 үшін FP4 қолдауы + 20+ кресло үшін мульти-агенттік оркестрация.</p></div>"
            },
            {
              id: "tech",
              tag: "СТЕК_2026",
              title: "Технологиялық Стек",
              content: "<div class='space-y-2'><p><strong>Көру:</strong> YOLO26/12 (End-to-End, STAL), MedSAM-3, NVIDIA Holoscan, Isaac ROS Stereo</p><p><strong>Аудио:</strong> DeepFilterNet 3 (турбина шуылын басу), Whisper v3 Turbo, Deepgram Nova-3 Medical</p><p><strong>Когнитив:</strong> Gemma 3 (Edge, 2B/8B), Gemini 3 Pro (Cloud Reasoning), Gemini Live (оқиғаларды талдау)</p></div>"
            },
            {
              id: "privacy",
              tag: "ҚҰПИЯЛЫЛЫҚ",
              title: "Құпиялылық және Қауіпсіздік",
              content: "<p>ҚР \"Дербес деректер туралы\" Заңына (94-V) толық сәйкестік:</p><ul class='list-disc pl-5 mt-2 space-y-1'><li><strong>Local-First:</strong> Бейнені клиника ішінде өңдеу (Edge/Local Server)</li><li><strong>Деидентификация:</strong> Беттерді бұлыңғырлау, PII жою</li><li><strong>Локализация:</strong> Қазақстандық серверлерде орналастыру мүмкіндігі</li></ul>"
            },
            {
              id: "features",
              tag: "ФУНКЦИЯЛАР",
              title: "Функциялар және Құндылық",
              content: "<div class='grid grid-cols-2 gap-4'><div><p class='text-amber font-bold'>Анти-Фрод Модулі</p><ul class='text-xs mt-1 space-y-1'><li>Фантомдық қызметтерді анықтау</li><li>Кассаны айналып өту аудио-триггерлері</li><li>Уақыттық алаяқтықты верификациялау</li></ul></div><div><p class='text-green-400 font-bold'>Клиникалық Ассистент</p><ul class='text-xs mt-1 space-y-1'><li>Сандық лупалар (2K zoom)</li><li>3D қауіпсіздік бақылауы</li><li>Авто-құжаттау</li></ul></div></div>"
            },
            {
              id: "google",
              tag: "ИНФРА",
              title: "Неге Google?",
              content: "<p class='mb-4'>Google — марафондарды жеңетін технологиялық алып. Gemini әлемдік бенчмарктарда көшбасшы. Біз 10 жылға жарамды іргетасты құрамыз.</p><ul class='list-disc pl-5 space-y-2'><li><strong>Vertex AI:</strong> Enterprise деңгейіндегі инфрақұрылым жаһандық қолжетімділікпен</li><li><strong>Edge TPU & Gemma:</strong> Деректер құпиялылығы үшін жергілікті инференс</li><li><strong>Gemini 3 Pro:</strong> Күрделі медициналық жағдайлар үшін SOTA мультимодальды пайымдау</li></ul><p class='mt-4 text-amber'>DentalGuard AI — жай камера емес. Медицинаны ашық, қауіпсіз және технологиялық ететін зияткерлік серіктес.</p>"
            }
          ]
        }
      },
      accountant: {
        title: "АРМ ЖЕ",
        desc: "Бухгалтерлік аутсорсинг үшін SaaS. AI-агент смета есептеу мен клиенттердің табыстылығын бақылауды автоматтандырады.",
        tech: "Go Agent • Google ADK • Gemini Embeddings",
        popup: {
          id: "arm-accountant",
          fullTitle: "АРМ Жүйелік Есепші",
          subtitle: "Бухгалтерлік компаниялар үшін зияткерлік автоматтандыру",
          status: "BETA",
          statusColor: "bg-purple-500/20 text-purple-400",
          sections: [
            {
              id: "summary",
              tag: "ШОЛУ",
              title: "Жоба туралы",
              content: "<p><strong>АРМ-ЖЕ</strong> — бухгалтерлік компаниялар үшін толық басқару циклін қамтитын кешенді SaaS-жүйе: қызмет құнын есептеуден клиенттердің табыстылығын бақылауға дейін.</p><p class='mt-2'>Жүйе жетекшілерге бизнестің нақты суретін көруге, ал бухгалтерлерге — тиімдірек жұмыс істеуге көмектеседі.</p><p class='mt-2 text-amber'>Негізгі идея: Бухгалтерия — бұл өндіріс, хаос емес. АРМ-ЖЕ \"шығармашылық тәртіпсіздікті\" өлшенетін, басқарылатын процеске айналдырады.</p>"
            },
            {
              id: "core",
              tag: "ФИЛОСОФИЯ",
              title: "Бақылаудың 4 кезеңі",
              content: "<div class='space-y-2'><p class='text-amber font-mono'>📋 ЖОСПАР → ⚡ ФАКТ → 🛡️ БАҚЫЛАУ → 📈 ӨСУ</p><ul class='list-disc pl-5 mt-3 space-y-1'><li><strong>Жоспар:</strong> Жұмыс көлемі мен құнын анықтаймыз (БухСмета)</li><li><strong>Факт:</strong> Орындалған тапсырмалар мен уақытты тіркейміз (ФРВ)</li><li><strong>Бақылау:</strong> Жоспар мен фактіні салыстырамыз, ауытқуларды табамыз</li><li><strong>Өсу:</strong> Процестерді жақсартамыз, нәтижені масштабтаймыз</li></ul></div>"
            },
            {
              id: "modules",
              tag: "МОДУЛЬДЕР",
              title: "Функционал + AI",
              content: "<div class='space-y-3'><p><strong>БухСмета:</strong> Қызметтерді бағалау → <span class='text-green-400'>AI: семантикалық іздеу, сметаларды автогенерациялау</span></p><p><strong>ФРВ:</strong> Жұмыс уақытын есепке алу → <span class='text-green-400'>AI: еңбек шығындарын болжау, шығынды анықтау</span></p><p><strong>БухЗадачник:</strong> Есептілік күнтізбесі → <span class='text-green-400'>AI: ақылды еске салу, AI-жоспарлау</span></p><p><strong>Стандарттау:</strong> Сапа чек-листтері → <span class='text-green-400'>AI: сапаны бақылау, үлгілерді анықтау</span></p></div>"
            },
            {
              id: "agent",
              tag: "AI_АГЕНТ",
              title: "BuhSmeta Agent",
              content: "<div class='space-y-2'><p><strong>Go 1.24 + Google ADK v0.3.0</strong> — зияткерлік автоматтандыру микросервисі.</p><ul class='list-disc pl-5 mt-2 space-y-1'><li><strong>Семантикалық іздеу:</strong> Қызметтерді кілт сөздер бойынша емес, мағынасы бойынша табады</li><li><strong>OCR Vision:</strong> Фото/PDF-тен деректемелерді лезде шығарады — жүктедің және дайын</li><li><strong>Tool Calling:</strong> ADK арқылы ДБ-мен интеграция</li><li><strong>Режимдер:</strong> template, search, auto — икемді маршруттау</li></ul><p class='mt-2 text-amber'>Gemini 3 Flash + Gemini Embeddings (1536 dim, MRL) + pgvector HNSW</p></div>"
            },
            {
              id: "stack",
              tag: "СИНЕРГИЯ",
              title: "Стек синергиясы",
              content: "<p class='mb-3'>Google ADK-дағы Go Agent төмен кідірісті және Gemini API-мен нативті интеграцияны қамтамасыз етеді. pgvector-дағы Embeddings сыртқы тәуелділіктерсіз семантикалық іздеуге мүмкіндік береді.</p><ul class='list-disc pl-5 space-y-1'><li><strong>Go + ADK:</strong> Жеңіл, жылдам, Google-мен нативті интеграция</li><li><strong>Gemini Embeddings:</strong> MRL қолдауымен 1536 өлшемді векторлар</li><li><strong>pgvector HNSW:</strong> Жергілікті векторлық іздеу, vendor lock-in жоқ</li></ul><p class='mt-3 text-amber'>Нәтиже: AI-функциялар enterprise ортасында жылдам және болжамды жұмыс істейді.</p>"
            }
          ]
        }
      },
    },
    stack: {
      title: "Технологиялық Стек 2026",
      columns: { tech: "Технология", app: "Қолданылуы" },
      items: [
        { tech: "Gemini 3 Pro / Flash / Live", app: "Пайымдау және нақты уақыттағы әрекеттесу" },
        { tech: "Google ADK", app: "Агенттер командаларын басқару" },
        { tech: "A2A Protocol", app: "Агентаралық байланыс стандарты" },
        { tech: "Google Antigravity & IDX", app: "Толық циклді жеделдету: Іздеу → Әзірлеу → Деплой" },
        { tech: "Project Mariner / Vertex AI", app: "Автономды навигация және Корпоративтік орналастыру" },
      ],
    },
    team: {
      title: "Команда",
      members: [
        { name: "Кирилл Зиновейкин", role: "Co-Founder & CEO", img: "/team/kirill.jpg", linkedin: "https://www.linkedin.com/in/zinoveyking/" },
        { name: "Геннадий Гоманович", role: "Co-Founder & CTO", img: "/team/gennady.JPG", linkedin: "https://www.linkedin.com/in/gennady87/" },
      ]
    },
    contact: {
      title: "Желіге Қосылу",
      email: "info@next3.ai",
      address: "Космонавтов к., 12, Қарағанды, 100022, Қазақстан",
      form: {
        name: "Аты (Callsign)",
        phone: "Қауіпсіз Желі",
        email: "Email (Байланыс арнасы)",
        message: "Миссия Хаттамасы",
        submit: "Деректерді Жіберу",
      },
      placeholders: {
        names: ["Агент Смит", "Нео", "Декард", "Кибер-V", "Мотоко", "47"], // Names often stay international or transliterated
        phones: ["+7 (777) 777-77-77", "+7 (701) 555-01-99", "+7 (727) 333-22-11", "+1 (555) 019-2834"],
        emails: ["neo@matrix.com", "hero@next3.ai", "admin@cyber.net", "guest@future.io"],
        messages: ["Эвакуация сұралуда...", "Жүйені бұзу анықталды...", "Хаттама іске қосылды...", "Деректер пакетін жүктеу...", "Байланыс тұрақсыз..."],
      },
    },
    nav: {
      features: "Жобалар",
      stack: "Стек",
      team: "Команда",
      contact: "Байланыс",
    },
    footer: {
      copyright: "next³ Agentic AI Lab © 2026",
      powered: "Google Cloud • Vertex AI • Astana Hub",
    },
  },
};
